import { FC } from "react";
import ModalHeading from "./ModalHeading";

import { Button, QRCode, Spin, Switch, message } from "antd";

import { RiLinkM } from "react-icons/ri";
import { AiOutlineGlobal } from "react-icons/ai";
import { IoCopyOutline, IoEyeOutline } from "react-icons/io5";
import { useIntl } from "react-intl";

import { useSelector } from "react-redux";

interface CatalogModalWrapperProps {
  catalogModal?: any;
  have_catalog_link: 1 | 0;
  isLoading: boolean;
  catalogLink: string;
  handleCreateLink: (params: any) => Promise<void>;
  handleRemoveLink: (params: any) => Promise<void>;
}
const downloadQRCode = () => {
  const canvas = document
    .getElementById("myqrcode")
    ?.querySelector<HTMLCanvasElement>("canvas");
  if (canvas) {
    const url = canvas.toDataURL();
    const a = document.createElement("a");
    a.download = "QRCode.png";
    a.href = url;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
};
const CatalogModalWrapper: FC<CatalogModalWrapperProps> = ({
  catalogLink,
  have_catalog_link,
  isLoading,
  handleCreateLink,
  handleRemoveLink,
  catalogModal,
}) => {
  const domain = window.location.origin;

  const intl = useIntl();

  return (
    <div>
      <div>
        <div className="p-4 space-y-4">
          <ModalHeading
            title={intl.formatMessage({ id: "ready_link_title" })}
            description={intl.formatMessage({ id: "ready_link_description" })}
          />
          {have_catalog_link ? (
            <div className="space-y-3">
              <div className="p-5  flex items-center justify-between gap-2 rounded h-16 bg-[#EEF0FF]">
                <Button
                  type="link"
                  htmlType="button"
                  onClick={() => {
                    navigator.clipboard.writeText(domain + "/" + catalogLink);
                    message.success(
                      intl.formatMessage({ id: "copy_link_success" })
                    );
                  }}
                >
                  <IoCopyOutline size={20} color="#9999A7" />
                </Button>
                <div className="flex items-center justify-between gap-4 h-full">
                  <span className="text-color-primary">
                    {domain + "/" + catalogLink}
                  </span>
                  <RiLinkM size={18} color="#7FE1C2" />
                </div>
              </div>
              <p className="text-color-sec-title text-center">
                {intl.formatMessage({ id: "copy_code_click" })}
              </p>
            </div>
          ) : null}
          {have_catalog_link ? (
            <div
              id="myqrcode"
              className="mx-auto flex flex-col justify-center items-center py-2 px-4 rounded bg-[#EEF0FF] w-fit"
            >
              <QRCode
                value={domain + "/" + catalogLink}
                bgColor="#EEF0FF"
                color="#00086D"
              />
              <Button
                type="text"
                className="text-color-primary font-semibold"
                onClick={downloadQRCode}
              >
                {intl.formatMessage({ id: "downloadButton" })}
              </Button>
            </div>
          ) : null}
          <div className="flex justify-between ">
            <div>
              <p className="px-2 flex items-center gap-2 ">
                <AiOutlineGlobal color="#7FE1C2" />
                <span className="text-color-sec-title">
                  {" "}
                  {intl.formatMessage({ id: "activateLink" })}
                </span>
              </p>
            </div>
            <div>
              <Switch
                loading={isLoading}
                checked={!!have_catalog_link}
                checkedChildren={intl.formatMessage({ id: "activated" })}
                unCheckedChildren={intl.formatMessage({ id: "deactivated" })}
                size="default"
                onChange={(e) => {
                  if (e === true) {
                    handleCreateLink({
                      link_type: "catalog_link",
                      value: 1,
                    });
                  } else {
                    handleRemoveLink({
                      link_type: "catalog_link",
                      value: 0,
                    });
                  }
                }}
              />
            </div>
          </div>
          {have_catalog_link ? (
            <div className="flex justify-center">
              <a href={domain + "/" + catalogLink} target="_blank">
                <p className="px-2 flex items-center gap-2 h-8">
                  <IoEyeOutline color="#7FE1C2" />
                  <span className="text-color-primary">
                    {" "}
                    {intl.formatMessage({ id: "viewLink" })}
                  </span>
                </p>
              </a>
            </div>
          ) : null}
        </div>
      </div>
      {/* )} */}
    </div>
  );
};

export default CatalogModalWrapper;
